import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CancelAuthenticationService } from '../../multi-factor-authentication-adapter-service/cancel-authentication/cancel-authentication.service';
import { ContinueAuthenticationService } from '../../multi-factor-authentication-adapter-service/continue-authentication/continue-authentication.service';
import { FlyDeltaPollService } from '../../multi-factor-authentication-adapter-service/fly-delta-poll/fly-delta-poll.service';
import { InitiateAuthenticationService } from '../../multi-factor-authentication-adapter-service/initiate-authentication/initiate-authentication.service';
import { LoginAlternativeAuthenticationService } from '../login-passwordless-adapter-service/login-alternative-authentication/login-alternative-authentication.service';
import { LoginUserIdentifierService } from '../login-passwordless-adapter-service/login-user-identifier/login-user-identifier.service';
import { LoginPostWithContinueService } from '../login-remember-me-adapter-service/login-post-with-continue/login-post-with-continue-service';
import { LoginPostWithRememberUserService } from '../login-remember-me-adapter-service/login-post-with-remember-user/login-post-with-remember-user-service';
import { LoginRememberMeErrorUtilService } from '../login-remember-me-utils-service/login-remember-me-error-util.service';
import { LoginRememberMeUtilsService } from '../login-remember-me-utils-service/login-remember-me-utils.service';

@Injectable({
  providedIn: 'root'
})
export class LoginSubmitAuthenticationIdentifierHelperExtendedService {
  stopPoll$ = new Subject();
  flowId = '';
  encyToken = '';
  uid = '';

  loginUserIdentifier = inject(LoginUserIdentifierService);
  initiateAuthentication = inject(InitiateAuthenticationService);
  flyDeltaPoll = inject(FlyDeltaPollService);
  continueAuthentication = inject(ContinueAuthenticationService);
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  cancelAuthentication = inject(CancelAuthenticationService);
  loginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  loginPostWithRememberUser = inject(LoginPostWithRememberUserService);
  loginPostWithContinue = inject(LoginPostWithContinueService);
  loginAlternativeAuthentication = inject(
    LoginAlternativeAuthenticationService
  );
}
